export const skillsDBPrefix = '/skills';
export const resumeProfileMembersPrefix = `${skillsDBPrefix}/members`;
export const resumeProfilesPrefix = `${skillsDBPrefix}/resume_profiles`;

export const getExtIntQueryKey = (isExternal?: boolean) => {
    return isExternal ? 'external' : 'internal';
};
